import { Baby, ChartBar, Heart, House, PhoneCall, WhatsappLogo } from "@phosphor-icons/react";


const cards = [
	{
		icon: <Heart size={36} color="#000" />,
		title: 'Cuidado Coordenado',
		subTitle: 'Notrelife - Qualivida',
		description: 'Screening populacional e monitoramento de público geral',
		link: 'https://app.notrelife.healthidlab.com.br/sistema',
		target: '',
		available: true
	},
	{
		icon: <Baby size={36} color="#000" />,
		title: 'Gestantes ID',
		subTitle: 'Programa gestação segura',
		description: 'Screening populacional e monitoramento de gestantes',
		link: 'https://gestantesid.com.br/sistema/login',
		target: '',
		available: true
	},
	{
		icon: <ChartBar size={36} color="#000" />,
		title: 'Perfil saúde',
		subTitle: 'pme',
		description: 'Screening populacional e monitoramento de pequenas e médias empresas',
		link: 'https://sistemascliclaudossaude.com.br',
		target: '',
		available: true
	},
	{
		icon: <WhatsappLogo size={36} color="#000" />,
		title: 'Blip - portal',
		subTitle: 'notrelife - qualivida - viver bem',
		description: 'Canal de gestão do chatbot e envio de mensagens em massia via WhatsApp',
		link: 'https://healthid.blip.ai/login',
		target: '_blank',
		available: true
	},
	{
		icon: <PhoneCall size={36} color="#000" />,
		title: 'blip -  desk',
		subTitle: 'notrelife - qualivida - viver bem',
		description: 'Canal de atendimento humano via WhatsApp',
		link: 'https://healthid.desk.blip.ai/',
		target: '_blank',
		available: true
	},
	{
		icon: <House size={36} color="#000" />,
		title: 'disparo de campanhas e palestras',
		subTitle: 'todas as areas',
		description: 'Disparo em massa via WhatsApp para divulgação de eventos.',
		link: 'https://hub.hapvida.healthidlab.com.br/',
		target: '',
		available: false
	},
]

export default cards;